import React from "react";
import { ProtectedLayout } from "../../layouts";
import { ImageInput,Input, Titlebar } from "../../components";
import { useFormik } from "formik";
import { newsSchema } from "../../utils/schemas";
import { Button } from "react-bootstrap";
import ReactQuill from "react-quill";
import { NewsService } from "../../service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function AddNews() {
  const navigate = useNavigate();

  // const onSubmit = async (values) => {
  //   try {
  //     let form = new FormData();
  //     form.append("file", values.image);
  //     Object.keys(values).forEach((key) => {
  //       if (key !== "image") {
  //         form.append(key, values[key]);
  //       }
  //     });
  //     await NewsService.create(form);
  //     toast.success("News successfully added!");
  //     navigate("/news");
  //   } catch (error) {
  //     toast.error("Error while storing!");
  //   }
  // };
  const onSubmit = async (values) => {
    try {
      let form = new FormData();
      form.append("file", values.image);
  
      // Add debugging to see form data
      console.log("Submitting form with data:", values);
  
      Object.keys(values).forEach((key) => {
        if (key !== "image") {
          form.append(key, values[key]);
        }
      });
  
      const response = await NewsService.create(form);
      
      if (response && response.status === 200) {
        toast.success("News successfully added!");
        navigate("/news");
      } else {
        throw new Error("Failed to add news on server.");
      }
  
    } catch (error) {
      console.error("Error during form submission:", error);
      toast.error("Error while storing!");
    }
  };
  
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      heading: "",
      description: "",
      image: null,
    },
    validationSchema: newsSchema,
    onSubmit: onSubmit,
  });

  return (
    <ProtectedLayout>
      <Titlebar title="Add New News" />
      <form onSubmit={handleSubmit}>
      <ImageInput
          label="Cover Photo"
          name="image"
          value={values.image}
          errors={errors.image}
          touched={touched.image}
          setFieldValue={setFieldValue}
        />
        <Input
          label="Heading"
          placeholder="Enter Heading"
          name="heading"
          value={values.heading}
          errors={errors.heading}
          touched={touched.heading}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <div className="mb-3">
          <div className="bg-white">
            <ReactQuill
              theme="snow"
              value={values.description}
              onChange={(value) => setFieldValue("description", value)}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, 4, 5, 6, 0] }],
                  ["bold", "italic", "underline"],
                  ["image", "code-block"],
                  [{ 'header': 1 }, { 'header': 2 }], // Additional header styles
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Ordered and unordered lists
                  ['link', 'blockquote', 'code'], // Link, blockquote, and code
                  [{ 'align': [] }], // Text alignment
                  [{ 'indent': '-1' }, { 'indent': '+1' }], // Indentation
                  ['table'], // Table module
                ],
              }}
              placeholder="Compose an epic..."
            />
          </div>
          {errors.description && touched.description && (
            <p className="text-danger mt-1 mb-0">{errors.description}</p>
          )}
        </div>
        <div className="text-end">
          <Button type="submit">Save</Button>
        </div>
      </form>
    </ProtectedLayout>
  );
}
